// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"afecef45","621":"ce2f21c7","743":"6cd9723e"}[chunkId] + ".chunk.js";
};